import { create } from 'zustand';

/** Глобальное состояние интерфейса: тема, свёрнутый rail, оверлеи. */

export type Theme = 'light' | 'dark';

export type UiState = {
  readonly theme: Theme;
  readonly isRailCollapsed: boolean;
  readonly isQuickCreateOpen: boolean;
  readonly isHotkeyHelpOpen: boolean;
  setTheme: (theme: Theme) => void;
  toggleTheme: () => void;
  setRailCollapsed: (collapsed: boolean) => void;
  toggleRail: () => void;
  setQuickCreateOpen: (open: boolean) => void;
  setHotkeyHelpOpen: (open: boolean) => void;
};

const THEME_STORAGE_KEY = 'tasks.theme';

function readStoredTheme(): Theme {
  if (typeof window === 'undefined') {
    return 'light';
  }
  return window.localStorage.getItem(THEME_STORAGE_KEY) === 'dark' ? 'dark' : 'light';
}

function persistTheme(theme: Theme): void {
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(THEME_STORAGE_KEY, theme);
  }
  if (typeof document !== 'undefined') {
    document.documentElement.dataset['theme'] = theme;
  }
}

export const useUiStore = create<UiState>((set, get) => ({
  theme: readStoredTheme(),
  isRailCollapsed: false,
  isQuickCreateOpen: false,
  isHotkeyHelpOpen: false,
  setTheme: (theme) => {
    persistTheme(theme);
    set({ theme });
  },
  toggleTheme: () => {
    get().setTheme(get().theme === 'dark' ? 'light' : 'dark');
  },
  setRailCollapsed: (isRailCollapsed) => set({ isRailCollapsed }),
  toggleRail: () => set((state) => ({ isRailCollapsed: !state.isRailCollapsed })),
  setQuickCreateOpen: (isQuickCreateOpen) => set({ isQuickCreateOpen }),
  setHotkeyHelpOpen: (isHotkeyHelpOpen) => set({ isHotkeyHelpOpen }),
}));
